module.exports = __webpack_public_path__ + "img/009.b28fabb0.jpg";